/* eslint-disable no-nested-ternary */
// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'
// import { noColorTypes } from 'bam-node-baseball-savant/apps/utils/possible-comp-tool-stats.ts'
import { StatSliderProps } from './utils/types.ts'
import ValueElement from './ValueElement.tsx'

import {
    RECT_HEIGHT,
    VALUE_FONT_SIZE,
    DEFAULT_WIDTH,
    SAVANT_GREEN,
    VALUE_WIDTH,
    VALUE_BUFFER,
    DARKER_GOLD,
} from './utils/constants.ts'

import { colorScale } from './utils/helpers.ts'
import DiagonalHatchDef from './DiagonalHatchDef.tsx'
import { useMode } from './utils/mode.tsx'

// const NO_SCALE_COLOR = '#b4cfd1'
// const NO_SCALE_COLOR = '#777777'

function StatSlider(props: StatSliderProps) {
    const {
        statName,
        percentile,
        maxSliderWidth,
        showValues,
        showWinner,
        isWinner,
        value,
        isNarrow,
        isFake,
        uniqueId,
    } = props

    const mode = useMode()

    const isNull = percentile === null
    const isValueNull = value === null

    const colWidth = showValues
        ? maxSliderWidth - 2 * DEFAULT_WIDTH - VALUE_WIDTH
        : maxSliderWidth - 2 * DEFAULT_WIDTH
    const scaledVal = isNull ? 0 : (percentile / 100) * colWidth
    const rectWidth = showValues ? maxSliderWidth - VALUE_WIDTH : maxSliderWidth

    const valueXOffset = isNarrow ? 0 : maxSliderWidth - VALUE_BUFFER

    let colorToUse

    if (isNull) {
        colorToUse = '#aaaaaa'
    } else {
        colorToUse =
            !showWinner || (showWinner && isWinner)
                ? String(colorScale(percentile))
                : '#aaaaaa'
    }

    return (
        <>
            {isFake || isNull ? (
                <DiagonalHatchDef
                    playerId={uniqueId}
                    statName={statName}
                    color={colorToUse}
                />
            ) : null}

            {/* Golden rectangle only if this is the winner and we're
            showing the winner */}
            {isWinner && showWinner ? (
                <rect
                    x="-1"
                    y="-1"
                    width={maxSliderWidth + 2}
                    height={RECT_HEIGHT + 2}
                    stroke="gold"
                    strokeWidth="3"
                    fill="gold"
                />
            ) : null}

            {/* Show the little underlying "axis" rectangle unless we're
            in narrow mode and showing values */}
            {!(isNarrow && showValues) ? (
                <rect
                    key={`${statName}_baseline_rect`}
                    x="0"
                    y={RECT_HEIGHT / 3}
                    width={rectWidth}
                    height={RECT_HEIGHT / 3}
                    stroke={isNull ? 'gray' : SAVANT_GREEN}
                    fill={isNull ? 'gray' : SAVANT_GREEN}
                    opacity={isNull ? 0.4 : 1}
                />
            ) : null}

            {/* Show the actual slider if value is not null 
            (whether qualified or not) and we're not in narrow
            showing values mode */}
            {!(showValues && isNarrow) && !isValueNull && !isFake ? (
                <>
                    <rect
                        key={`${statName}_rect`}
                        x="0"
                        y="0"
                        width={scaledVal + DEFAULT_WIDTH}
                        height={RECT_HEIGHT}
                        stroke={colorToUse}
                        fill={colorToUse}
                    />

                    <circle
                        key={`${statName}_circle`}
                        cx={scaledVal + DEFAULT_WIDTH}
                        cy={RECT_HEIGHT / 2}
                        r={RECT_HEIGHT / 2}
                        stroke={showWinner && isWinner ? DARKER_GOLD : 'white'}
                        strokeWidth="2"
                        fill={colorToUse}
                    />

                    <text
                        key={`${statName}_value_text`}
                        className="label-text-value"
                        x={scaledVal + DEFAULT_WIDTH}
                        y={(RECT_HEIGHT - VALUE_FONT_SIZE) / 2 + 2}
                        fill="white"
                        textAnchor="middle"
                        dominantBaseline="hanging"
                        fontWeight="800"
                        fontSize="9"
                        style={{ fontFamily: 'Roboto Condensed' }}
                        textLength={percentile === 100 ? 14 : undefined}
                    >
                        {percentile}
                    </text>
                </>
            ) : null}

            {!(showValues && isNarrow) &&
            !isValueNull &&
            isFake &&
            percentile ? (
                <>
                    {/* <rect
                        key={`${statName}_rect_bkgd`}
                        x="0"
                        y="0"
                        width={rectWidth * (percentile / 100)}
                        height={RECT_HEIGHT}
                        stroke="none"
                        fill={colorToUse}
                        opacity="0.1"
                    />
                    <rect
                        key={`${statName}_rect`}
                        x="0"
                        y="0"
                        width={rectWidth * (percentile / 100)}
                        height={RECT_HEIGHT}
                        stroke={colorToUse}
                        strokeOpacity="0.5"
                        fill={`url(#diagonal-hatch-${playerId}-${statName})`}
                        opacity="0.9"
                    /> */}

                    <rect
                        key={`${statName}_rect`}
                        x="0"
                        y="0"
                        width={scaledVal + DEFAULT_WIDTH}
                        height={RECT_HEIGHT}
                        stroke="none"
                        fill={`url(#${mode}-diagonal-hatch-${uniqueId}-${statName})`}
                    />

                    <circle
                        key={`${statName}_circle`}
                        cx={scaledVal + DEFAULT_WIDTH}
                        cy={RECT_HEIGHT / 2}
                        r={RECT_HEIGHT / 2}
                        stroke={
                            showWinner && isWinner ? DARKER_GOLD : colorToUse
                        }
                        strokeWidth="2"
                        strokeOpacity="0.6"
                        fill={`url(#${mode}-diagonal-hatch-${uniqueId}-${statName})`}
                    />
                </>
            ) : null}

            {/* Show value element no matter what if we're showing value --
            logic is handled within */}
            {showValues ? (
                <g transform={`translate(${valueXOffset}, 0)`}>
                    <ValueElement
                        value={value}
                        type={statName}
                        isNarrow={isNarrow}
                        maxSliderWidth={maxSliderWidth}
                        fill={colorToUse}
                        boldWinner={
                            showValues && showWinner && isWinner && !isNarrow
                        }
                        isUnqualified={percentile === null}
                        isFake={isFake}
                        playerId={uniqueId}
                    />
                </g>
            ) : null}

            {/* Golden rectangle helper at top only if this is the
            winner and we're showing the winner */}
            {isWinner && showWinner ? (
                <rect
                    x="-1"
                    y="-1"
                    width={maxSliderWidth + 2}
                    height={RECT_HEIGHT + 2}
                    stroke={DARKER_GOLD}
                    strokeWidth="3"
                    fill="transparent"
                />
            ) : null}
        </>
    )
}

export default StatSlider
